import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading
} from '../../styles/account/account'
import { DashboardWrapper } from '../../container/dashboardWrapper'
import { InputWrapper } from '../../components/input/input.style'
import { Button } from '../../components/button'
import { Checkbox } from '../../components/checkbox'
import { Breadcrumb } from '../../components/breadcrumb/breadcrumb'

const AccountNotificationScreen = () => {
    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container>
                    <MainContent>
                        <Heading>
                            Notifications
                        </Heading>
                        {/* TODO: BREADCRUMB */}
                        <Breadcrumb
                            crumbs={['account', 'notifications']}
                        />
                        <form>
                            <InputWrapper>
                                <Checkbox
                                    id="emailsFromTeachers"
                                    label="Emails from Teachers"
                                    type="checkbox"
                                    helperText="Get messages, encouragement and helpful information from your teachers."
                                    fullWidth
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Checkbox
                                    id="profileInfoVisible"
                                    label="Make my profile info visible to other students."
                                    type="checkbox"
                                    fullWidth
                                    helperText="If unchecked, your profile will be private and no one except you will be able to view it."
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Checkbox
                                    id="displayMyPosts"
                                    label="Display my posts in the class feed"
                                    type="checkbox"
                                    fullWidth
                                    helperText="When you post on groups, everyone including admins will see them."
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Checkbox
                                    id="publishmyAssignment"
                                    label="Publish my assignment scores to class feed."
                                    type="checkbox"
                                    fullWidth
                                    helperText="If checked, Your scores will be visible to everyone in your class."
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Checkbox
                                    id="SubjectUpdates"
                                    label="Subject Updates"
                                    type="checkbox"
                                    fullWidth
                                    helperText="Be the first to know when new and existing subjects are updated."
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Checkbox
                                    id="KlassconnectNewsletter"
                                    label="Klassconnect Newsletter"
                                    type="checkbox"
                                    fullWidth
                                    helperText="Get the latest on company news."
                                />
                            </InputWrapper>
                            <Button
                                type="submit"
                                style={{ marginLeft: 'auto' }}
                                variant="secondary"
                                responsive
                            >
                                SAVE CHANGES
                            </Button>
                        </form>
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper>
    )
}

export default AccountNotificationScreen
